import React, { useState, useEffect } from 'react';
import { purchaseOrdersAPI } from '../services/api';
import './Modal.css';

function PurchaseOrderDetailModal({ poId, onClose }) {
    const [details, setDetails] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (poId) {
            loadDetails();
        }
    }, [poId]);

    const loadDetails = async () => {
        try {
            setLoading(true);
            const response = await purchaseOrdersAPI.getAll({ header_id: poId });
            if (response.success) {
                setItems(response.data);
                // Basic header info can be derived from the first item or fetched separately if needed
                // But the current API returns a flat list of items joined with header info?
                // Let's check the API response structure from purchase_orders.js
                // It returns "details" which is an array of rows.
            } else {
                setError('No se pudo cargar el detalle.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const formatCurrency = (val) => {
        return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(val);
    };

    if (!poId) return null;

    return (
        <div className="modal-overlay" onClick={onClose} style={{ zIndex: 1100 }}> {/* Higher z-index to overlay on IRDetail */}
            <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ width: '80%', maxWidth: 'none' }}>
                <div className="modal-header">
                    <h2>Orden de Compra #{poId}</h2>
                    <button className="close" onClick={onClose}>&times;</button>
                </div>

                <div className="modal-body">
                    {loading ? (
                        <div className="loading">Cargando orden...</div>
                    ) : error ? (
                        <div className="alert alert-error">{error}</div>
                    ) : (
                        <div className="table-responsive">
                            <table className="comparison-table">
                                <thead>
                                    <tr>
                                        <th>Artículo</th>
                                        <th>Código</th>
                                        <th className="text-right">Cant.</th>
                                        <th className="text-right">Precio Unit.</th>
                                        <th className="text-right">Total</th>
                                        <th className="text-right">Recibido</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item, idx) => (
                                        <tr key={item.puODDetailId || idx}>
                                            <td>
                                                <strong>{item.article_description}</strong><br />
                                                <small>{item.article_model}</small>
                                            </td>
                                            <td>{item.article_code}</td>
                                            <td className="text-right">{item.puODQuantity} {item.unit_description}</td>
                                            <td className="text-right">{formatCurrency(item.puODSinglePrice)}</td>
                                            <td className="text-right">{formatCurrency(item.puODTotalAmount)}</td>
                                            <td className="text-right">{item.puODReceptionQuantity}</td>
                                        </tr>
                                    ))}
                                    <tr className="table-footer">
                                        <td colSpan="4" className="text-right"><strong>Total Estimado:</strong></td>
                                        <td className="text-right">
                                            <strong>{formatCurrency(items.reduce((acc, curr) => acc + (parseFloat(curr.puODTotalAmount) || 0), 0))}</strong>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className="modal-actions">
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PurchaseOrderDetailModal;
